import React, { useState, useEffect } from "react";
import Sidebar from "../../shared/sidebar/Sidebar";
import Navbar from "../../shared/navbar/Navbar";
import ErrorMessages from "../../shared/errormessages/ErrorMessages";
import DataTable from "../../shared/datatable/DataTable";
import { format } from "fecha";
import axios from 'axios'

const Training = () => {
  const [pageState, setPageState] = useState({ loading: false})
  const [pageData, setPageData] = useState({
      status: "",
      data: [],
      total: 0
  })

  const [errors, setErrors] = useState("");
  const [search, setSearch] = useState("");

  useEffect(()=>{
    if(pageState.loading == false){
      axios.get('/training/getlist?search=' + search )
        .then(function (response) {
          if(response.data.status == "success"){
            setErrors("");
            setPageData(response.data);
            setPageState({loading: true});
          }
          else{
            setErrors(response.data.message);
          }
        })
        .catch(function (error) {
          setErrors(error.message);
        });
    }
  })

  const model = {
    columns: [
      {
        field: "Label",
        headerName: "Behaviour",
        width: 200,
      },
      {
        field: "Color",
        headerName: "Color",
        width: 100,
        renderCell: (params) => {
          const bgStyle = {
            backgroundColor: params.row.Color,
            color: "#fff",
            fontWeight: "bold",
            borderRadius: "50%",
            width: "32px",
            height: "32px",
          };
          return <span style={bgStyle}>&nbsp;</span>;
        },
      },
      {
        field: "LastUpdatedOn",
        headerName: "Last Updated On",
        width: 150,
        renderCell: (params) => {
          return (
            params.row.LastUpdatedOn && (
              <span>
                {format(new Date(params.row.LastUpdatedOn), "DD/MM/YYYY HH:mm")}
              </span>
            )
          );
        }
      },
      {
        field: "Text",
        headerName: "Text",
        width: 500,
        renderCell: (params) => {
          return (
            <p>{params.row.Text}</p>
          );
        },
      },
    ],
    modulename: "Training",
  };

  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar title={model.modulename} />
        <ErrorMessages message={errors} />
        <DataTable  {...model} rows={pageData.data} checkboxSelection={true} setPageState={setPageState} setSearch={setSearch} />
      </div>
    </div>
  );
};

export default Training;
